// 3rd party imports
import * as React from 'react';
import { inject } from 'mobx-react';

// bernie
import { ContextStore, RouteStore } from 'bernie-core';

import { UiStore } from 'stores';
import { UitkSpacing } from 'uitk-react-spacing';
import { FlexDocumentDialog } from 'components/documents/flex-document-dialog';
import { ILocalization, LocalizedComponentProps, withLocalization } from '@shared-ui/localization-context';

export interface FlexDocumentProps extends LocalizedComponentProps {
  context?: ContextStore;
  l10n?: ILocalization;
  routeStore?: RouteStore;
  uiStore?: UiStore;
  documentName: string;
}

@withLocalization
@inject('context', 'routeStore', 'uiStore')
export class FlexDocument extends React.Component<FlexDocumentProps, any> {
  constructor(props) {
    super(props);
  }

  public componentDidMount() {
    this.props.routeStore.updateSearch({ pwaDialog: 'flex-document-dialog' });
  }

  public render() {
    const { uiStore, l10n } = this.props;

    const documentName = uiStore?.documentName;
    const documentPrefix = uiStore?.flexDocumentPrefix;

    const locale = this.props.context.locale;
    const url = `${documentPrefix}/lp/b/affhub/${documentName}?siteid=2055&locale=${locale}`;
    const headerName =
      {
        'terms-of-use': 'terms.page.title',
        'privacy-policy': 'privacy.policy.page.title',
        'cookie-policy': 'cookie.policy.page.title',
      }[documentName] || false;
    const headerText = headerName ? l10n.formatText(headerName) : '';

    return (
      <UitkSpacing className="container--small" padding={{ block: 'twelve' }}>
        <FlexDocumentDialog url={url} headerText={headerText} />
      </UitkSpacing>
    );
  }
}
